import { schema } from 'normalizr';

const accountRegistrationSchema = new schema.Entity(
  'accountRegistrations',
  {},
  { idAttribute: 'uuid' }
);

export default accountRegistrationSchema;
